module.exports = __webpack_public_path__ + "img/set_icon.d5645eaa.png";